import { ApplicationElement, html } from '@effectivastudio/lit-components';
import style from './style.lit.css';
import IconBlock from '@effectivastudio/lit-components/components/icon_block/element.js';
import '../icon/element.js';

/**
 * Icon block with font-awesome
 *
 */
export default class BuIconBlock extends IconBlock {
  static styles = [ApplicationElement.styles, style];

  render() {
    return html`
      <bu-icon name=${this.icon}></bu-icon>
      <span><slot>${this.text}</slot></span>
    `;
  }
}

customElements.get('bu-icon-block') ||
  customElements.define('bu-icon-block', BuIconBlock);
